/******************************************************************************
 mlib-components
 Library for UI components widely used in LB apps.
 (c) Longboard Architectural Products
 ******************************************************************************/
import axios from 'axios';
import RunConfig from '../RunConfig/runconfig.js';

var apiUrl = RunConfig === null || RunConfig === void 0 ? void 0 : RunConfig.apiUrl;
var instance = axios.create({
    baseURL: apiUrl,
    headers: {
        "Content-Type": "application/json",
    },
});
var loginGoogle = function (googleToken) {
    return new Promise(function (resolve, reject) {
        instance
            .post("/auth", { token: googleToken })
            .then(function (resp) {
            var token = resp.data;
            instance
                .get("".concat(apiUrl, "/auth"), {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(token.access_token),
                },
            })
                .then(function (resp) { return resolve(token); })
                .catch(function (error) { return reject(error); });
        })
            .catch(function (error) { return reject(error); });
    });
};
var loginEmail = function (email) {
    return new Promise(function (resolve, reject) {
        instance
            .post("".concat(apiUrl, "/auth"), { email: email })
            .then(function (resp) { return resolve(resp.data); })
            .catch(function (error) { return reject(error); });
    });
};
var loginToken = function (token) {
    return new Promise(function (resolve, reject) {
        instance
            .put("".concat(apiUrl, "/auth"), { refresh_token: token })
            .then(function (resp) { return resolve(resp.data); })
            .catch(function (error) { return reject(error); });
    });
};
var requestPermissions = function (googleToken) {
    return new Promise(function (resolve, reject) {
        instance
            .post("/auth/permissions", { token: googleToken })
            .then(function (resp) { return resolve(resp.data); })
            .catch(function (error) { return reject(error); });
    });
};
var refreshToken = function (token) {
    return new Promise(function (resolve, reject) {
        instance
            .post("".concat(apiUrl, "/auth/refresh"), { refresh_token: token })
            .then(function (resp) { return resolve(resp.data); })
            .catch(function (error) { return reject(error); });
    });
};
var getCurrentUser = function (accessToken) {
    return new Promise(function (resolve, reject) {
        instance
            .get("".concat(apiUrl, "/auth"), {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(accessToken),
            },
        })
            .then(function (resp) { return resolve(resp.data); })
            .catch(function (error) { return reject(error); });
    });
};
var checkDefaultRole = function (accessToken) {
    return new Promise(function (resolve, reject) {
        instance
            .get("".concat(apiUrl, "/auth/test/role"), {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(accessToken),
            },
        })
            .then(function (resp) { return resolve(resp.data); })
            .catch(function (error) { return reject(error); });
    });
};
var checkFakeRole = function (accessToken) {
    return new Promise(function (resolve, reject) {
        instance
            .get("".concat(apiUrl, "/auth/test/forbidden"), {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(accessToken),
            },
        })
            .then(function (resp) { return resolve(resp.data); })
            .catch(function (error) { return reject(error); });
    });
};
var logout = function (accessToken) {
    return new Promise(function (resolve, reject) {
        instance
            .delete("/auth", {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(accessToken),
            },
        })
            .then(function (resp) { return resolve(resp.data); })
            .catch(function (error) { return reject(error); });
    });
};

export { checkDefaultRole, checkFakeRole, getCurrentUser, instance, loginEmail, loginGoogle, loginToken, logout, refreshToken, requestPermissions };
